import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/default.vue")),
  "must-read": defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/must-read.vue")),
  unauthenticated: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/unauthenticated.vue"))
}